interface ISummaryInfoProps {
  title: string;
  value: string;
}

export const SummaryInfo: React.FC<ISummaryInfoProps> = (props) => {
  const { title, value } = props;

  return (
    <div className='mb-20 xl:mb-24 pb-16 border-b border-dashed border-neutral-20 last:border-b-0'>
      <h3 className='text-12 xl:text-14 leading-16 xl:leading-18 mb-4 text-blue_grey-80'>{title}</h3>
      <p className='text-12 xl:text-14 leading-16 xl:leading-18'>{value}</p>
    </div>
  );
};
